(function(){
    'use strict';

    angular.module('tmx-app')
        .directive('mobileList', [mobileList]);

    function mobileList() {

        var directive={
            restrict: 'E',
            scope: {
                kendogrid: '=',
                data: '=',
                columns: '='
            },
            templateUrl: 'common/directives/mobilelist/mobileList.html',
            controller: ["$scope","$timeout",mobileListCtrl],
       /* controller:function($scope){
        },*/
            controllerAs:'mobileListCtrl'
        };
        return directive; 
    }

    function mobileListCtrl($scope,$timeout){
        var vm=this;
        vm.scope=$scope;
        vm.gridData=vm.scope.data;
        vm.gridColumns=vm.scope.columns;
        vm.cols={};
        vm.table=[];

        vm.initCols=function(){

            for(var i=0;i<vm.gridColumns.length;i++){
                vm.cols[vm.gridColumns[i].field]={
                    enable:true,
                    label:vm.gridColumns[i].title
                };
            }
        };
        vm.initCols();//calls the initializaton functon
        vm.isInCol=function(col){
           

            return angular.isDefined(vm.cols[col]) && vm.cols[col].enable; 
        };
      
        vm.getLabel=function(col){
            if(angular.isDefined(vm.cols[col]))
                return vm.cols[col].label;
        };
      

        vm.getTable=function(){
            var table=[];
           
            for(var i=0;i<vm.gridData.length;i++){
                var obj={};
                for (var key in vm.gridData[i]) {
                    if (vm.gridData[i].hasOwnProperty(key) && vm.isInCol(key)) {
                        var value = vm.gridData[i][key];
                        obj[key]=value;
                    }
                }
                table.push(obj);
            }
            return table;
        }

        vm.hasQuery=function(row,query){
            for (var key in row) {
                if (vm.gridData[i].hasOwnProperty(key) && vm.isInCol(key)) {
                    var value = vm.gridData[i][key];
                    obj[key]=value;
                }
            }
        }

        vm.updateTable=function(){
            vm.table=vm.getTable();
            if(vm.table.length<0){
                $timeout(vm.updateTable,100);
            }
        }
      
        $timeout(vm.updateTable,100);
    }


})();